import React, { useMemo } from 'react';
import { Label } from 'fronton-react';
import { container } from './styles';
import { UOMS } from 'features/product-info/constants';

type TProps = {
  amountBox: number;
  areaPerBox: number;
  mainUom?: string;
  additionalUomRus?: string;
  mainUnit: string | null;
};

export const PdpProjectBoxCount: React.FC<TProps> = ({
  amountBox,
  areaPerBox,
  mainUom,
  additionalUomRus,
  mainUnit,
}) => {
  const approximateAreaForAllBoxes = useMemo(() => {
    return Math.floor(amountBox * areaPerBox * 1000) / 1000;
  }, [amountBox, areaPerBox]);

  const isBoxMain = mainUom === UOMS.CAR;
  const boxUomRus = isBoxMain ? mainUnit : additionalUomRus;
  const m2UomRus = isBoxMain ? additionalUomRus : mainUnit;

  return (
    <div data-qa="pdp-project-box-count" className={container}>
      <Label background="background-primary" borderColor="control-minor" color="text-secondary">
        {amountBox} {boxUomRus} = {approximateAreaForAllBoxes} {m2UomRus}
      </Label>
    </div>
  );
};
